import { Type } from '@angular/core';
import { FilterTypesEnum } from '../../../../../Common/Filter/enums/filters-types.enum';
import { AbstractFilterTypeComponent } from '../../../../../Common/Filter/models/abstract-filter-type.component';
import { CustomFilterTypeModel } from '../../../../../Common/Filter/models/custom-filter-type.model';
import { FilterOptionModel } from '../../../../../Common/Filter/models/filter-option.model';
import { FilterTypeCheckboxModel } from '../../../../../Common/Filter/models/filter-type-checkbox.model';
import { ChipModel } from '../../../../../Common/Forms/models/chip.model';
import { MediaTypeModel } from '../../../../../Monitor/Shared/models/media-type.model';
import { FilterSectionEnum } from '../../../../../Common/Filter/enums/filter-section.enum';

export const SHOW_ALL_UNTAGGED_MENTIONS_CHIP: ChipModel = {
    label: 'Monitoring.tagFilter.excludeAllChipLabel'
};

export class FilterTypeStreamContentCheckboxModel extends FilterTypeCheckboxModel<MediaTypeModel> implements CustomFilterTypeModel<MediaTypeModel[]> {
    readonly key: FilterTypesEnum = FilterTypesEnum.custom;

    customComponent: Type<AbstractFilterTypeComponent>;

    constructor(
        id: string,
        label: string,
        component: Type<AbstractFilterTypeComponent>,
        options?: FilterOptionModel<MediaTypeModel>[],
        value?: MediaTypeModel[],
        section?: FilterSectionEnum

    ) {
        super(id, label, options, true, null, value, null, null, section);
        this.customComponent = component;
    }
}
